var hasBackgroundClass = function (className) {
    return !!className && /(^|\s)bg-/.test(className);
};
export var getCardStyles = function (borderRadius, shadowSize, className) {
    return "rounded-".concat(borderRadius, " shadow-").concat(shadowSize).concat(hasBackgroundClass(className) ? '' : ' bg-white');
};
//# sourceMappingURL=card.styles.js.map